import './styles/logs-filter.scss'

import React       from 'react'
import PropTypes   from 'prop-types'
import { connect } from 'react-redux'
import classnames  from 'classnames'

import { setFilter } from '../redux/actions/items'
import DateTimeRangeFilter from '../components/DateTimeRangeFilter'

class LogsFilter extends React.Component {
  static propTypes = {
    onFilterChange: PropTypes.func.isRequired,
    selectedCategory: PropTypes.string.isRequired,
    filterCriteria: PropTypes.object,
  }

  handleSelect = (region) => {
    const regionFilters = [...this.getSelectedRegions()]

    // toggle the selected region
    const index = regionFilters.indexOf(region)
    if (index > -1) {
      regionFilters.splice(index, 1)
    } else {
      regionFilters.push(region)
    }
    if (regionFilters.length === 0) {
      const otherRegion = region === window.config.region ? window.config.drRegion : window.config.region
      regionFilters.push(otherRegion)
    }

    const { filterCriteria = {}, selectedCategory } = this.props
    this.props.onFilterChange({
      ...(filterCriteria[selectedCategory] || {}),
      regionFilters,
    })
  }

  getSelectedRegions = () => {
    const { filterCriteria = {}, selectedCategory } = this.props
    const { regionFilters = [window.config.region] } = filterCriteria[selectedCategory] || {}

    return regionFilters
  }

  handleTimeChange = (params) => {
    const { filterCriteria = {}, selectedCategory } = this.props
    this.props.onFilterChange({
      ...(filterCriteria[selectedCategory] || {}),
      createdTimeFilter: params,
    })
  }

  getSelectedTimeFilterConfig = () => {
    const { filterCriteria = {}, selectedCategory } = this.props
    const { createdTimeFilter = undefined } = filterCriteria[selectedCategory] || {}

    return createdTimeFilter
  }

  render() {
    const { selectedCategory } = this.props
    const selectedTimeFilterConfig = this.getSelectedTimeFilterConfig()
    const regionFilters = this.getSelectedRegions()

    const primarySelected = regionFilters && regionFilters.includes(window.config.region)
    const drSelected = regionFilters && regionFilters.includes(window.config.drRegion)

    const primaryRegionClass = classnames('ui left attached button', { selected: primarySelected })
    const drRegionClass = classnames('ui right attached button', { selected: drSelected })

    let hintMessage = ''

    if (primarySelected && drSelected) {
      hintMessage = 'Showing logs for primary and dr regions'
    } else if (primarySelected) {
      hintMessage = `Showing logs for primary region`
    } else if (drSelected) {
      hintMessage = `Showing logs for dr region`
    }

    return (
      <div className="logs-filter">
        <div className="time-filter">
          <DateTimeRangeFilter
            key={selectedCategory}
            onChange={this.handleTimeChange}
            defaultFilterConfig={selectedTimeFilterConfig}
          />
        </div>
        <div className="region-filter">
          <div className="hint">{hintMessage}</div>
          <div>
            <div
              className={primaryRegionClass}
              role="button"
              tabIndex="0"
              onClick={() => this.handleSelect(window.config.region)}
            >
              {window.config.region}
            </div>
            <div
              className={drRegionClass}
              role="button"
              tabIndex="0"
              onClick={() => this.handleSelect(window.config.drRegion)}
            >
              {window.config.drRegion}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = {
  setFilter,
}
const mapStateToProps    = (state) => ({
  filterCriteria: state.items.filterCriteria,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LogsFilter)
